<template>
	<div class="AppNavBar">
		<div class="AppNavBar__all-fields ">
			<div class="AppNavBar__sales-field">
				<h3 class="font-semibold p-2 text-orange">
					Sales Performance By Location
				</h3>
			</div>
			<!-- desktop view -->
			<div class="AppNavBar__desktop-view flex items-center">
				<p class="px-2 mx-2 text-heading1">
					developer@gmail.com
				</p>
				<el-select v-model="value" placeholder="Select" class="p-2 mx-2">
					<el-option
						v-for="item in 5"
						:key="item.value"
						:label="item"
						:value="item"
					/>
				</el-select>
			</div>
			<button
				class="mobile-button flex items-center
            px-3 py-2 mx-3 border border-rounded
            text-amp border-amp
            hover:text-amp-btn2 hover:border-amp-btn2
            focus:outline-none"
				@click="showDropdown"
			>
				<svg
					class="fill-current h-3 w-3"
					viewBox="0 0 20 20"
					xmlns="http://www.w3.org/2000/svg"
				>
					<title>Menu</title>
					<path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
				</svg>
			</button>
		</div>
		<!-- mobile view -->
		<div v-if="toggleMenu" class="dropdown">
			<div class="AppNavBar__mobile-view">
				<p class="p-2 mx-2 text-blue-dark">
					developer@gmail.com
				</p>
				<el-select v-model="value" placeholder="Select" class="p-2 mx-2">
					<el-option
						v-for="item in 5"
						:key="item.value"
						:label="item"
						:value="item"
					/>
				</el-select>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "AppNavBar",
	mixins: [],
	props: [],
	data() {
		return {
			value: "",
			toggleMenu: false
		};
	},
	methods: {
		showDropdown() {
			this.toggleMenu = !this.toggleMenu;
		}
	}
};
</script>

<style lang="scss" scoped>
.AppNavBar {
	background-color: #ffff;
}
.AppNavBar .AppNavBar__all-fields {
	height: 60px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.AppNavBar__mobile-view {
	background-color: #f4f3ef;
	padding: 15px 0;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.AppNavBar .mobile-button {
	display: none;
}
.AppNavBar .dropdown {
	display: none;
}
@media screen and(max-width:768px) {
	.AppNavBar .mobile-button {
		display: block;
	}
	.AppNavBar .dropdown {
		display: block;
	}
	.AppNavBar .AppNavBar__desktop-view {
		display: none;
	}
}
</style>
